import React from 'react'
import Card from 'atoms/Card'
import Banner from 'atoms/Banner'
import NetWorthGraph from 'layouts/authenticated/pages/newdash/components/NetWorthGraph'
import NetWorthTable from 'layouts/authenticated/pages/newdash/components/NetWorthTable'

import { useModal } from 'components/modals'

import { useCallback, useState, useEffect, useMemo, useContext } from 'react'
import { apiClient } from 'utils/api/apiClient'
import { IntakeContext } from 'context/IntakeContext'

function NetWorthUnlock() {
  const { intakeState } = useContext(IntakeContext)
  const { openModal } = useModal()

  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])

  const getAccounts = useCallback(async () => {
    try {
      const {
        data: { items },
      } = await apiClient.get('api/assets')

      const foundAssets = items?.filter(({ type }) => type === 'asset') || []
      setAssets(foundAssets)

      const foundLiabilities =
        items?.filter(({ type }) => type === 'liability') || []
      setLiabilities(foundLiabilities)
    } catch (error) {
      console.error('Failed to fetch accounts', error)
    }
  }, [])

  useEffect(() => {
    getAccounts()
  }, [getAccounts])

  const hasThriftSavingsPlan = assets?.some(
    (item) =>
      item.externalAsset === true &&
      item.externalInstitutionName === 'Thrift Savings Plan'
  )

  const assetSum =
    (assets || []).map((assets) => assets.amount).reduce((a, b) => a + b, 0) +
    (hasThriftSavingsPlan
      ? 0
      : (intakeState.tspBalance ? intakeState.tspBalance : 0) +
        (intakeState.tspRothBalance ? intakeState.tspRothBalance : 0))

  const liabilitySum = (liabilities || [])
    .map((liabilities) => liabilities.amount)
    .reduce((a, b) => a + b, 0)

  const netWorth = assetSum - liabilitySum

  return (
    <div
      style={{
        boxShadow: '0px 4px 25px -8px rgba(0, 0, 0, 0.15)',
        borderRadius: 22,
      }}
    >
      <Card
        header={
          <Banner
            color={'white'}
            type={'header'}
            actionText="ADD / LINK ACCOUNT"
            clickAction={() => {
              openModal('addAccounts', {
                getAccounts: getAccounts,
                openToPage: 0,
              })
            }}
            title="MY NET WORTH"
            description={netWorth}
            formatDescription
            counterDescription
            subText="up"
            content={<NetWorthGraph netWorth={netWorth} />}
          />
        }
      >
        <NetWorthTable
          getAccounts={getAccounts}
          assets={assets}
          liabilities={liabilities}
        />
      </Card>
    </div>
  )
}

export default NetWorthUnlock
